import { areWeInStorybook, areWeTestingWithJest, isDevEnv, isMergeRequestPreviewEnvironment, } from "@buildwithflux/shared";
import { concatErrorArgs } from "../flux_error";
/**
 * If `condition` is falsey, throw a hard error in dev mode, or log a soft error in
 * prod.
 *
 * NOTE: this does not include the `asserts condition` TS declaration, because
 * in prod mode the caller needs to actually handle the falsey case, and so we
 * don't want TS to think it's definitively truthy.
 *
 */
export function devAssert(assertTrueConditionAndErrorIfFalse, message, logger, cause) {
    if (!assertTrueConditionAndErrorIfFalse) {
        const error = new Error(...concatErrorArgs(message, cause));
        const isNonProdEnv = isDevEnv() || areWeTestingWithJest() || isMergeRequestPreviewEnvironment() || areWeInStorybook();
        if (isNonProdEnv) {
            if (areWeTestingWithJest() && !("error" in logger) && "cause" in error) {
                // eslint-disable-next-line no-console -- needed or we never display the cause
                console.error(error);
            }
            throw error;
        }
        else {
            if ("captureError" in logger) {
                logger.captureError(error);
            }
            else {
                logger.error(error);
            }
        }
    }
}
/**
 * Helper assertion that adds a type guard.
 *
 * Note: assumes type T is truthy.
 */
export function devAssertVar(variable, logger) {
    // Stack trace should provide more context within Sentry.
    // QUESTION: is this actually the case? Do we need to add more info here?
    const message = "Unexpected undefined variable.";
    devAssert(variable, message, logger); // Throws in dev
    return !!variable;
}
//# sourceMappingURL=devAssert.js.map